import {api} from '../../utils/api'
import {synchronizer} from "@/utils/synchronizer";
//import {synchronizer} from '../../utils/synchronizer'

export default {

    /**
     * Get tasks list
     * @param state
     * @returns {default.campaigns|{}}
     */
    getTasksList: state => (parentID) => {

        // Return tasks list
        return Object.values(state.tasks).filter(task => {
            return (task.parent_id == parentID);

        }).sort((a, b) => parseFloat(a.position) - parseFloat(b.position));
    },

    /**
     * Get parents
     * @param state
     */
    getParents: state => (nodeId) => {

        // Get current node
        let cNode = state.tasks[nodeId];

        // Parents list
        let parents = [nodeId]

        // Find root
        while (cNode && cNode.parent_id && (cNode = state.tasks[cNode.parent_id])) {
            // Add parent
            parents.push(cNode.id);
        }

        // Return parents list
        return parents;
    },

    /**
     * Get node workspace
     * @param state
     */

    getWorkspace: state => (nodeId) => {

        // Get current node
        let cNode = state.tasks[nodeId];

        // Find root
        while (cNode && cNode.parent_id && (cNode = state.tasks[cNode.parent_id])) {
            // Check for parent type
            if(cNode.type == 'workspace') return cNode;
        }
    },

    /**
     * Get node project
     * @param state
     */

    getProject: state => (nodeId) => {

        // Get current node
        let cNode = state.tasks[nodeId];

        // Find root
        while (cNode && cNode.parent_id && (cNode = state.tasks[cNode.parent_id])) {
            // Check for parent type
            if(cNode.type == 'project') return cNode;
        }
    },

    /**
     * Check if node has parent of "template" type
     * @param state
     * @param getters
     */

    isTemplate: (state, getters) => (nodeId) => {
        // Check parents for template
        return getters['getParents'](nodeId).filter(el => (state.tasks[el].type == 'template')).length > 0
    },

    /**
     * Check if node has parent of "template" type
     * @param state
     * @param getters
     */

    isWorkspaceTemplate: (state, getters) => (nodeId) => {
        // Check parents for template
        return getters['getParents'](nodeId).filter(el => (state.tasks[el].subtype == 'workspace' && state.tasks[el].type == 'template')).length > 0
    },

    /**
     * Get child tasks
     * @param state
     * @param getters
     * @param rootState
     * @param rootGetters
     */
    getChildrenTasks: (state, getters, rootState, rootGetters) => ({id, mode}) => {

        // find children with params
        return getters['collectChildrenTasks']({
            id,
            mode,
            notficiationFilter: rootGetters['tree/getTreeNotificationFilter'],
            filterByIds: rootGetters['tree/getFilterByTasks']
        })
    },


    /**
     * Get child tasks
     * @param state
     * @param getters
     * @param rootState
     * @param rootGetters
     */
    collectChildrenTasks: (state, getters, rootState, rootGetters) => ({id, mode, notficiationFilter, filterByIds}) => {

        // If parent == -1 - return all tasks
        let returnAllTasks = !mode ? 0 : 1;//id < 0 ? 1 : 0;

        // Set real parent
        const parent_id = id < 0 ? 0 : id;

        // Roles list
        let glRoles = {},
            locRoles = {},
            queryResult = {},
            tasksList = [],

            // If notification filter is enabled - nodes represented as a list
            hasSubParent = false;

        // Convert single value to array
        if(notficiationFilter && !Array.isArray(notficiationFilter)) {
            notficiationFilter = [notficiationFilter]
            glRoles['await_children'] = 1
        }

        // Get tasks ids to filter by
        const hasFilterByIds = filterByIds && Object.values(filterByIds).length > 0;

        // Get parents access
        for (const nodeId of rootGetters['tree/getTasksParents'](parent_id).reverse()) {

            // Get node id
            const pNode = state.treeTasks[nodeId];

            // Check for at least one repeater
            if (pNode && ['repeater'].includes(pNode.type)) hasSubParent = true;

            // Check for roles
            for (const [role, owner] of Object.entries(rootGetters['taskuser/getUserRolesList'](nodeId))) {
                // Local roles
                locRoles[role] = owner;

                // Global roles
                if (["i_supervisor", "i_spectator"].includes(role)) glRoles[role] = owner;
            }

            // Checking for a closed mode
            if(pNode && pNode.show_closed_children) {
                glRoles['closed_children'] = 1;
            }

            // Checking for a await mode
            if(pNode && pNode.show_await_children) {
                glRoles['await_children'] = 1;
            }

            // Checking for a deferred mode
            if(pNode && pNode.show_deferred_children) {
                glRoles['deferred_children'] = 1;
            }
        }

        // Get tags
        const isDeferred = hasFilterByIds || rootGetters['tree/getTaskListTags'].includes("deferred");
        const isClosed = hasFilterByIds || rootGetters['tree/getTaskListTags'].includes("closed");

        // Recursive function
        function processNode(node_id, globalRoles, result) {

            // Get node id
            const node = state.treeTasks[node_id];

            // Skip deleted nodes
            if(node && node.deleted_at) return false;

            // Get count
            const messagesCount = rootGetters["notifications/getNotificationsCount"]({
                task_id: node_id,
                type: ["mention-comment", "comment", "favorite"],
                zone: "local"
            }) + rootGetters["notifications/getNotificationsCount"]({
                task_id: node_id,
                type: ["mention-comment", "comment", "favorite"],
                zone: "global"
            });

            // Notification filter
            const notFilterCount = notficiationFilter ? rootGetters["notifications/getNotificationsCount"]({
                task_id: node_id,
                type: notficiationFilter,
                zone: "local"
            }) : false;

            // Get node roles
            let roles = Object.assign({}, globalRoles);
            roles = Object.assign(roles, rootGetters['taskuser/getUserRolesList'](node_id));

            // New global roles
            let newGlRoles = {};

            // Create new global roles list to pass to the children
            for(const [role, owner] of Object.entries(roles)) {
                if (["i_supervisor", "i_spectator", 'await_children','closed_children', 'deferred_children'].includes(role)) newGlRoles[role] = owner;
            }

            // Checking for a closed mode
            if(node && node.show_closed_children) {
                newGlRoles['closed_children'] = 1;
            }

            // Checking for a await mode
            if(node && node.show_await_children) {
                newGlRoles['await_children'] = 1;
            }

            // Checking for a deferred mode
            if(node && node.show_deferred_children) {
                newGlRoles['deferred_children'] = 1;
            }

            // Skip closed and deferred nodes
            if (node &&
                (
                    (   (
                            (node.deferred / 1000 > api.getUnixTime() && !isDeferred && !newGlRoles['deferred_children']) ||
                            (node.state == 100 && !isClosed && !newGlRoles['closed_children'])
                        ) && !messagesCount)
                    || (node.state === 50 && !roles['i_supervisor'])

                    || (node.state === 1000)
                )
            ) return 0; /**/

            // Local result
            let localResult = {};

            // Has child active nodes
            let hasActNodes = 0;

            // Add res
            if (
                node &&
                parent_id !== node_id &&

                (
                    // Access rights
                    (
                        // Supervisors
                        roles['i_supervisor']

                        // Spectators
                        || roles['i_spectator']

                        // Assignees
                        || notFilterCount > 0

                        // Followers
                        || (
                            (roles['i_follower'])
                        )

                        // Assignees
                        || (
                            (node.state == 10 || node.state == 100) &&
                            ((roles['i_assignee']) || (roles['i_assignee_position'] && roles['o_assignee'] === undefined))
                        )

                        // Acceptors
                        || (
                            (node.state == 30 || node.state == 100) &&
                            (roles['i_assignee'] || (roles['i_acceptor']) || (roles['i_acceptor_position'] && roles['o_acceptor'] === undefined))
                        )
                    ) &&

                    // Experiment await_children
                    (roles['await_children'] || !node.original_task_id || node.type !== "task" || ![5].includes(node.state)) &&

                    // Notification filter
                    (
                        notFilterCount === false || notFilterCount > 0
                    ) &&

                    // Filter by ids test
                    (
                        !hasFilterByIds || filterByIds[node_id]
                    )
                )
            ) {
                // Expand nodes if filter mode
                if(notficiationFilter || hasFilterByIds) window.app.$dispatch("tree/expandNode", {id: node_id, expanded: true});

                // Add results
                result[node_id] = 1;

                // Not all tasks should be returned
                if(!returnAllTasks) return 1;
            }

            // Process child node
            for (const childId of getters.getChildren(node_id)) {

                // Node has some items
                hasActNodes += processNode(childId, newGlRoles, localResult);
            }

            // Check for parent nodes
            if (node &&

                // Return all tasks
                !returnAllTasks &&

                // Skip global parent
                parent_id !== node_id &&

                // Check for project or repeater
                (
                    // if first repeater in the path - use it
                    (!hasSubParent && ["repeater", "instance"].includes(node.type) && hasActNodes > 0)

                    // Project partition should always be
                    || ( ( (!mode && "project" === node.type) || "workspace" === node.type) && hasActNodes > 0)
                )
            )
            {
                localResult = {};
                localResult[node_id] = 1;

                // Expand nodes if filter mode
                if(notficiationFilter || hasFilterByIds) window.app.$dispatch("tree/expandNode", {id: node_id, expanded: true});
            }

            // Store local result to the global result
            for (const id of Object.keys(localResult)) result[id] = 1;

            // Has active nodes
            return hasActNodes;
        }

        // Recursive processing
        processNode(parent_id < 0 ? 0 : parent_id, glRoles, queryResult);

        // Load nodes
        for (const nId of Object.keys(queryResult)) {
            //if(state.tasks[nId]) tasksList.push(Object.assign(state.tasks[nId], {parent_id}));
            if (state.treeTasks[nId]) tasksList.push(state.treeTasks[nId]);
        }

        // Return tasks list
        return tasksList.sort((a, b) => (parseFloat(a.position) - parseFloat(b.position)));
    },

    /**
     * Get child tasks lists
     * @param state
     */
    getChildren: state => (parent_id) => {

        // Return children list
        return Object.keys(state.tree[parent_id] ? state.tree[parent_id] : {});
    },

    /**
     * Get first active child
     * @param state
     * @param getters
     */
    getFirstActiveChild: (state, getters) => (parent_id) => {

        // Last child
        let lastChild = 0;

        // Explore level
        function goDeep(node) {

            // Check for active child
            if ([10, 30].includes(node.state)) return node;

            // Store last child
            lastChild = node;

            // Process child items
            for (const child of getters.getChildrenTasks({id:node.id})) {
                const aid = goDeep(child);
                if (aid) return aid;
            }

            // Nothing found
            return false;
        }

        // Get active child
        const actNode = goDeep(parent_id ? state.tasks[parent_id] : {id: 0, state: 0});

        // Return children list
        return actNode ? actNode : lastChild;
    },

    /**
     * Get users tasks list
     * @param state
     * @returns {default.campaigns|{}}
     */
    getAllTasksList: state => {

        // Return tasks list
        return Object.values(state.tasks);
    },

    /**
     * Get tables list
     * @param state
     * @returns {default.campaigns|{}}
     */
    getTablesList: state => {

        // Return tasks list
        return Object.values(state.tasks).filter(task => {
            return (task.type === 'table');
        });
    },

    /**
     * Get tasks parents
     * @param state
     * @returns {default.campaigns|{}}
     */
    getTasksParents: state => (taskID, objs) => {

        // Get current task
        let task = state.tasks[taskID];

        // Parents list
        let parents = [];

        // Get parents list
        while (task) {
            // Add parent task
            parents.push(objs ? task : task.id);

            // Go to parent task
            task = state.tasks[task.parent_id];
        }

        // Return tasks list
        return parents;
    },

    /**
     * Get task sources
     * @param state
     * @returns {default.sources|{}}
     */
    getTaskSources: state => (taskID) => {

        // Get current task
        let task = state.tasks[taskID];

        // Parents list
        let parents = [];

        // Get parents list
        while ((task = state.tasks[task.parent_id])) {
            // Get items
            Object.values(state.tasks).map(t => {
                if (t.parent_id == task.id && api.clearInstance(t.id) != api.clearInstance(taskID)) parents.push(t);
            });
        }

        // Return tasks list
        return parents;
    },

    /**
     * Get source nods list
     * @param state
     * @returns {default.sources|{}}
     */
    getSourceNodes: state => ({nodeId, type}) => {

        // Get current task
        let task = state.tasks[nodeId];

        // Parents list
        let parents = [];

        // Get parents list
        while ((task = state.tasks[task.parent_id])) {
            // Get items
            Object.values(state.tasks).map(t => {
                if (t.parent_id == task.id && t.type == type) parents.push(t);
            });
        }

        // Return tasks list
        return parents;
    },

    /**
     * Get allowed nodes from the project
     * @param state
     * @param getters
     * @returns {default.sources|{}}
     */
    getAllowedProjectNodes: (state, getters) => ({nodeId, type}) => {

        // Get project node
        const prs = getters['getParents'](nodeId), projId = prs[prs.length-2];

        // find children with params
        const tasks = getters['collectChildrenTasks']({
            id: projId,
            mode: 1
        }).filter(el => el.type == type).map(el => (el.id))

        // Return list
        return tasks;
    },

    /**
     * Get child tasks with notifications
     * @param state
     * @returns {default.sources|{}}
     */
    getChildWithNotification: state => (taskID) => {

        // Get child
        let child = function (parID) {
            for (let itm of Object.values(state.tasks).filter((i) => i.parent_id == parID)) {
                // check for personal notifications
                if (itm.notifications_count > 0) return itm;

                // Go to child
                let iRes = child(itm.id);

                // Check for result
                if (iRes) return iRes;
            }

            // nothing found
            return false;
        };

        // Return task
        return child(taskID);
    },

    /**
     * Get task processes
     * @param state
     * @returns {default.sources|{}}
     */
    getProcesses: state => {

        // Create empty list
        let list = {};

        // Process values
        Object.values(state.tasks).filter(t => t.type == 'template').map((i) => {
            // Get task id
            let clI = api.cleanTaskInstances(["id"], i);

            // Store task
            list[clI.id] = clI;
        });

        // Return list
        return Object.values(list);
    },

    /**
     * Get expanded tasks
     * @param state
     * @returns {default.sources|{}}
     */
    getExpanded: state => {
        // Return expanded nodes
        return Object.keys(state.expandedNodes);
    },

    /**
     * Get closed task mode
     * @param state
     * @returns {default.sources|{}}
     */
    getClosedChildrenMode: state => (id) => {
        // Check closed mode
        return state.treeTasks[id] && state.treeTasks[id].show_closed_children;
    },

    /**
     * Get await task mode
     * @param state
     * @returns {default.sources|{}}
     */
    getAwaitChildrenMode: state => (id) => {
        // Check closed mode
        return state.treeTasks[id] && state.treeTasks[id].show_await_children;
    },

    /**
     * Get deferred task mode
     * @param state
     * @returns {default.sources|{}}
     */
    getDeferredChildrenMode: state => (id) => {
        // Check deferred mode
        return state.treeTasks[id] && state.treeTasks[id].show_deferred_children;
    },

    /**
     * Check tasks loaded
     * @param state
     * @returns {default.campaigns|{}}
     */
    checkTasksLoaded: state => {
        // Return tasks count
        return state.tasks ? true : false;
    },

    /**
     * Get task by id
     * @param state
     */
    getTaskByID: state => (id) => {

        // Get task
        const tsk = state.tasks[id];

        // Return task from list
        return tsk;
    },

    /**
     * Get task field by id
     * @param state
     */
    getTaskFieldByID: state => ({id, field}) => {

        // Get task
        const tsk = state.tasks[id];

        // Return task from list
        return tsk ? tsk[field] : false;
    },

    /**
     * Get task field by id
     * @param state
     */
    loadTaskFieldByID: state => ({id, field}) => {

        // Get task
        const tsk = state.tasks[id];

        // Load task if not loaded
        if(tsk === undefined || tsk[field] === undefined) {
            // Send load request
            synchronizer.addToLoader("tree-task", id);
        }

        // Return task from list
        return tsk ? tsk[field] : false;
    },

    /**
     * Get notification by id
     * @param state
     * @returns {default.campaigns|{}}
     */
    getNotificationByID: state => (id) => {
        // Return tasks list
        return state.taskNotification[id];
    },

    /**
     * Get next task by id
     * @param state
     * @returns {default.campaigns|{}}
     */
    getNextTask: (state, getters) => (payload) => {

        // Next task obj
        let nextTask = -1;

        // Process all tasks
        let tasks = getters.getChildrenTasks({id: payload.parent_id});

        // Process all tasks
        for (let i of tasks) {
            // Store task
            if (nextTask === 0) return state.tasks[i.id];

            // Mark current tasl
            if (i.id == payload.id) nextTask = 0;

        }

        // No next tasks
        return false
    },


    /**
     * Get prev task by id
     * @param state
     * @param getters
     * @returns {default.campaigns|{}}
     */
    getPrevTask: (state, getters) => (payload) => {

        // Prev task obj
        let prevTask = false;

        // Process all tasks
        let tasks = getters.getChildrenTasks({id: payload.parent_id});

        // Process all tasks
        for (let i of tasks) {
            // Mark current tasl
            if (i.id == payload.id) {
                return state.tasks[prevTask.id];
            }

            // Store previous task
            prevTask = i;
        }

        // No next tasks
        return false
    },

    /**
     * Get all tasks
     * @param state
     * @returns {default.campaigns|{}}
     */
    getAllTasks: state => {
        // Return full tasks list
        return Object.values(state.tasks).filter(t => t.id);
    },

    /**
     * Get active task id
     * @param state
     * @returns {default.campaigns|{}}
     */
    getActiveTaskID: state => {
        // Return tasks list
        return state.activeTaskID;
    },

    /**
     * Get task id to be copied
     * @param state
     * @returns {default.campaigns|{}}
     */
    getCopyTaskID: state => {
        // Return tasks list
        return state.copyTaskID;
    },
    /**
     * Get active task fiekd
     * @param state
     * @returns {default.campaigns|{}}
     */
    getActiveTaskField: state => {
        // Return tasks list
        return state.activeTaskField;
    },

    /**
     * Get active task id
     * @param state
     * @returns {default.campaigns|{}}
     */
    getTaskListMode: state => {
        // Return tasks list mode
        return state.tasksListMode;
    },

    /**
     * Get tasks list query string
     * @param state
     * @param query
     * @constructor
     */
    getTaskListQuery: state => {
        // Return query
        return state.tasksListQuery;
    },

    /**
     * Get tasks list query string
     * @param state
     * @param query
     * @constructor
     */
    getTaskListTags: state => {
        // Return query
        return state.tasksListTags;
    },

    /**
     * Get tree notification filter
     * @param state
     * @constructor
     */
    getTreeNotificationFilter: state => {
        // Return query
        return state.treeNotificationFilter;
    },

    /**
     * Get last update time
     * @param state
     * @param query
     * @constructor
     */
    getLastUpdateTime: state => {
        // Return query
        return state.lastUpdateTime;
    },

    /**
     * Get update hash
     * @param state
     * @param query
     * @constructor
     */
    getUpdateHash: state => {
        // Return query
        return state.updateHash;
    },

    /**
     * Get current task
     * @param state
     * @returns {default.campaigns|{}}
     */
    getCurrent: state => {
        // Return current task
        return state.currentTask ? state.tasks[state.currentTask] : false;
    },

    /**
     * Get current task
     * @param state
     * @returns {default.campaigns|{}}
     */
    getFilterByTasks: state => {
        // Return current task
        return state.filterByTasks;
    },

    /**
     * Get filtered task data
     * @param state
     * @returns {default.campaigns|{}}
     */
    getFilterByTaskData: state => (id) => {
        // Return current task
        return state.filterByTasks[id];
    }
}
